/**
 * Догоняет отображаемый прогресс до фактического «потолка» из onUploadProgress:
 * события axios при multipart приходят редко, иначе шкала «дергается».
 * Шкала задаётся колбэками getCurrent/setDisplay (например 0–100 или 0–50).
 */
export default class SmoothedUploadProgress {
  private reportedCap = 0;

  private timer: ReturnType<typeof setInterval> | null = null;

  constructor(
    private readonly getCurrent: () => number,
    private readonly setDisplay: (value: number) => void,
    private readonly tickIntervalMs = 1000
  ) {}

  start(): void {
    this.dispose();
    this.reportedCap = 0;
    this.setDisplay(0);
    this.timer = setInterval(() => this.tick(), this.tickIntervalMs);
  }

  /** Уже в той же шкале, что и setDisplay (как приходит из сети после масштабирования). */
  reportNetworkProgress(value: number): void {
    if (!Number.isFinite(value) || value < 0) {
      return;
    }
    this.reportedCap = Math.max(this.reportedCap, value);
  }

  dispose(): void {
    if (this.timer != null) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  private tick(): void {
    const cap = this.reportedCap;
    const current = this.getCurrent();
    if (current >= cap) {
      return;
    }
    const gap = cap - current;
    const step = Math.max(1, Math.ceil(gap / 2));
    this.setDisplay(Math.min(current + step, cap));
  }
}
